import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import englishTranslations from '../locales/en/main';
import japaneseTranslations from '../locales/ja/main';

i18n.use(initReactI18next).init({
  fallbackLng: import.meta.env.VITE_DEFAULT_LANG || 'en',
  lng: import.meta.env.VITE_DEFAULT_LANG || 'en',
  resources: {
    en: {
      translation: englishTranslations,
    },
    ja: {
      translation: japaneseTranslations,
    },
  },
});
